import { connect } from 'react-redux';
import {
    BILL_AGGREGATION_TYPE_OPTION_FIELD_NAME,
    BILL_ASSIGNMENT_TARGET_OPTION_FIELD_NAME,
    ITEM_ROUTING_OPTION_FIELD_NAME,
    ITEM_TYPES_FIELD_NAME,
    PREPAYMENT_FIELD_NAME,
    RoutingRuleFormValues,
    RoutingRuleItemRoutingOption,
    SERVICE_FIELD_NAME,
    TRIGGER_TYPE_OPTION_FIELD_NAME,
} from '@mews-commander/routing-rules';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { LocalizedText, lt, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import {
    RoutedItemType,
    RoutingRuleAssignmentTargetType,
    RoutingRuleBillAggregationType,
    RoutingRulePrepayment,
    RoutingRuleTriggerType,
} from '@mews-commander/data-access';
import { getUserPreferredServiceId } from '@mews-commander/legacy-entities/src/selectors/enterpriseServices';
import { createRoutingRules, navigateToRoutingRule } from '../actions';
import { RoutingRuleForm } from './RoutingRuleForm';

interface OwnProps {
    enterpriseId: string;
}

interface StateProps {
    initialValues: $TSFixMe;
}

interface DispatchProps {
    onSubmit: (values: $TSFixMe) => void;
    submitButtonProps: $TSFixMe;
}

export default connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    (state, { enterpriseId }) => ({
        initialValues: {
            [TRIGGER_TYPE_OPTION_FIELD_NAME]: RoutingRuleTriggerType.Continuous,
            [ITEM_ROUTING_OPTION_FIELD_NAME]: RoutingRuleItemRoutingOption.AllItems,
            [PREPAYMENT_FIELD_NAME]: RoutingRulePrepayment.All,
            [SERVICE_FIELD_NAME]: getUserPreferredServiceId(state, { enterpriseId }),
            [ITEM_TYPES_FIELD_NAME]: [RoutedItemType.CityTax, RoutedItemType.SpaceOrder],
            [BILL_ASSIGNMENT_TARGET_OPTION_FIELD_NAME]: RoutingRuleAssignmentTargetType.CompanyAsDetails,
            [BILL_AGGREGATION_TYPE_OPTION_FIELD_NAME]: RoutingRuleBillAggregationType.OnePerReservation,
        },
    }),

    (dispatch: CommanderThunkDispatch, { enterpriseId }) => ({
        onSubmit: async (values: RoutingRuleFormValues) =>
            dispatch(createRoutingRules({ enterpriseId, values })).then(({ value: routingRuleIds }) => {
                showSuccessAlert({ description: lt('SaveSuccessMessage') });
                dispatch(navigateToRoutingRule(routingRuleIds, enterpriseId));
            }),
        submitButtonProps: {
            label: <LocalizedText textKey={TextKey.Create} />,
        },
    })
)(RoutingRuleForm);
